
import { mapState, mapGetters } from 'vuex';
import WidgetType from '@/enums/WidgetType';
import WidgetStyle from '@/enums/WidgetStyle';
import AppHeaderV2ScoreSection from '@/components/common/AppHeaderV2/AppHeaderV2ScoreSection';
import AppHeaderV2MediaSummarySection from '@/components/common/AppHeaderV2/AppHeaderV2MediaSummarySection';
import ReviewsSummary from '@/views/widget/WidgetAddOnReviewsSummary/components/ReviewsSummary';
import WidgetAddOnSizeRecommendation from '@/views/widget/WidgetAddOnSizeRecommendation/WidgetAddOnSizeRecommendation';
import ReviewAskEntry from '@/components/review_ask/ReviewAskEntry';

export default {
  name: 'AppHeaderV2',
  components: {
    AppHeaderV2ScoreSection,
    AppHeaderV2MediaSummarySection,
    ReviewsSummary,
    WidgetAddOnSizeRecommendation,
    ReviewAskEntry
  },
  props: {
    params: { type: Object, default: () => ({}) }
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('sizeRecommendation', ['sizeRecommendationDisplayable']),
    ...mapGetters('widget', ['showVerifiedBuyerFilter']),
    WidgetType: () => WidgetType,
    WidgetStyle: () => WidgetStyle,
    displayReviewsSummary() {
      return (
        this.widget.widget_style === WidgetStyle.LIST_V3 &&
        this.widget.show_reviews_summary
      );
    },
    displayReviewAskEntry() {
      // 브랜드 활성·최소 후기 수 등 노출 조건 판정은 ReviewAskEntry가 config 조회로 스스로 한다.
      return (
        this.widget.widget_style === WidgetStyle.LIST_V3 &&
        this.widget.show_review_ask
      );
    },
    displayScoreSection() {
      if (!this.widget.show_score_section) return false;
      if (
        this.reviewSettings.use_product_category_product_type &&
        this.widget.show_evaluation_option_type_graph
      )
        return true;
      return (
        this.widget.show_product_score ||
        this.widget.show_product_score_histogram
      );
    },
    displayFilterSection() {
      return (
        this.widget.show_sort_section ||
        this.reviewSettings.enable_review_search ||
        this.widget.show_filter_section ||
        this.showVerifiedBuyerFilter
      );
    }
  }
};
